/** Guest QR menu (public, mobile-first) and the payment simulator checkout. */
export const enMenu = {
  'menu.loading': 'Loading the menu…',
  'menu.error.notFound': 'This QR code is no longer valid. Ask our staff for a new one.',
  'menu.error.load': 'The menu could not be loaded. Check your connection.',
  'menu.retry': 'Try again',
  'menu.table': 'Table {table}',
  'menu.language': 'Language',
  'menu.promos.title': 'Promotions',
  'menu.promos.slide': 'Promotion {index} of {count}',
  'menu.promos.previous': 'Previous promotion',
  'menu.promos.next': 'Next promotion',
  'menu.promos.until': 'Until {date}',
  'menu.promos.see': 'See on the menu',
  'menu.categories.label': 'Menu categories',
  'menu.empty': 'The menu is not available yet. Please ask our staff.',
  'menu.prices': 'Prices exclude {service}% service charge and {tax}% tax.',
  'menu.pricesTaxOnly': 'Prices exclude {tax}% tax.',
  'menu.item.soldOut': 'SOLD OUT',
  'menu.item.askWaiter': 'To order, please call a waiter.',
  'menu.item.choices': 'Choices',
  'menu.item.required': 'Choose {min}',
  'menu.item.upTo': 'Up to {max}',
  'menu.item.optional': 'Optional',
  'menu.item.howToOrder': 'To order, call our waiter — they will send it to the kitchen.',
  'menu.item.close': 'Close',
  'menu.item.photoBy': 'Photo: {name}',
  'menu.bill.open': 'Bill & pay',
  'menu.bill.openWithAmount': 'Bill · {amount}',
  'menu.bill.title': 'Bill',
  'menu.bill.subtitle': 'Table {table} · {branch}',
  'menu.bill.back': 'Back to the menu',
  'menu.bill.loading': 'Loading the bill…',
  'menu.bill.error': 'The bill could not be loaded.',
  'menu.bill.noSession':
    'Nobody is seated at this table yet. Once our waiter sends your order to the kitchen, it appears here.',
  'menu.bill.noItems':
    'Nothing has been sent to the kitchen yet. Items appear here once your order is sent.',
  'menu.bill.estimate': 'Estimate — the final bill is made when you pay.',
  'menu.bill.number': 'Bill {number}',
  'menu.bill.items': 'Your order',
  'menu.bill.subtotal': 'Subtotal',
  'menu.bill.service': 'Service charge {rate}',
  'menu.bill.tax': 'Tax {rate}',
  'menu.bill.rounding': 'Rounding',
  'menu.bill.total': 'Total',
  'menu.bill.paid': 'Paid',
  'menu.bill.outstanding': 'To pay',
  'menu.bill.updated': 'Updated {time}',
  'menu.bill.refresh': 'Refresh',
  'menu.bill.status.sent': 'Sent',
  'menu.bill.status.preparing': 'Preparing',
  'menu.bill.status.ready': 'Ready',
  'menu.bill.status.served': 'Served',
  'menu.pay.cta': 'Pay {amount} in the app',
  'menu.pay.starting': 'Opening payment…',
  'menu.pay.continue': 'Continue payment',
  'menu.pay.orCashier': 'You can also pay at the cashier.',
  'menu.pay.disabled': 'Paying in the app is not available here yet. Please pay at the cashier.',
  'menu.pay.nothing': 'Nothing left to pay. Thank you!',
  'menu.pay.secure':
    'Your payment is confirmed directly by the payment provider, never by this page.',
  'menu.pay.checking': 'Checking your payment…',
  'menu.pay.pending': 'Waiting for the payment provider to confirm {amount}.',
  'menu.pay.settled': 'Payment of {amount} received. Thank you!',
  'menu.pay.failed': 'The payment failed. Nothing was charged — you can try again.',
  'menu.pay.expired': 'The payment time ran out. You can try again.',
  'menu.pay.cancelled': 'This payment was replaced by a newer one.',
  'menu.pay.refund':
    'We received {amount}, but the bill was already paid. Our staff will refund you — please let them know.',
  'menu.pay.amountChanged': 'The bill changed. Check the new total, then pay again.',
  'menu.pay.sessionChanged': 'This table has new guests. Reload to see the current bill.',
  'menu.pay.rateLimited': 'Too many attempts. Wait a moment, then try again.',
  'menu.pay.error': 'The payment could not be started. Try again or pay at the cashier.',
  'menu.scan.title': 'Scan the QR code on your table',
  'menu.scan.description':
    'Every table has its own QR code. Point your phone camera at it to see the menu and your bill.',
  'menu.sim.badge': 'TEST MODE',
  'menu.sim.title': 'Payment simulator',
  'menu.sim.description':
    'Stands in for a payment provider during testing. No money moves. The result is sent to the restaurant as a signed callback.',
  'menu.sim.merchant': 'Merchant',
  'menu.sim.amount': 'Amount',
  'menu.sim.expires': 'Pay before {time}',
  'menu.sim.pay': 'Simulate successful payment',
  'menu.sim.fail': 'Simulate failed payment',
  'menu.sim.working': 'Sending…',
  'menu.sim.closed': 'This checkout is closed ({status}).',
  'menu.sim.back': 'Back to the bill',
  'menu.sim.notFound': 'This checkout does not exist.',
  // ---- Guest self-order (ADR-0029)
  'menu.item.quantity': 'Quantity',
  'menu.item.decrease': 'Decrease',
  'menu.item.increase': 'Increase',
  'menu.item.notes': 'Notes (optional)',
  'menu.item.notesPlaceholder': 'e.g. no onions',
  'menu.item.add': 'Add to order',
  'menu.item.chooseRequired': 'Choose {group} first',
  'menu.item.added': '{name} added to your order',
  'menu.cart.open': 'Order ({count})',
  'menu.cart.title': 'Your order',
  'menu.cart.empty': 'Nothing yet — pick something from the menu.',
  'menu.cart.remove': 'Remove {name}',
  'menu.cart.guests': 'Number of guests',
  'menu.cart.subtotal': 'Subtotal',
  'menu.cart.taxNote': 'Tax and service charge are added on the bill.',
  'menu.cart.send': 'Send to kitchen',
  'menu.cart.sending': 'Sending…',
  'menu.cart.sent': 'Order sent to the kitchen.',
  'menu.cart.error': 'Your order was not sent. Please try again.',
  'menu.cart.soldOut': 'Just sold out: {items}. Remove them and send again.',
  'menu.cart.tableUnavailable': 'This table cannot take orders right now. Please call a waiter.',
  'menu.cart.rateLimited': 'Too many orders from this table. Please wait a moment.',
  'menu.cart.retry': 'Try again',
  'menu.orders.title': 'Ordered at this table',
  'menu.orders.total': 'Ordered so far',
  'menu.orders.status.sent': 'SENT',
  'menu.orders.status.preparing': 'COOKING',
  'menu.orders.status.ready': 'READY',
  'menu.orders.status.served': 'SERVED',
  'menu.orders.status.cancelled': 'CANCELLED',
} as const;
